'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactSearchController = function () {
  function ContactSearchController(authService, enums, contactService, $state, loadingService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactSearchController);
    if (!authService.validateUser(false, 'Contact', enums.PERMISSION_TYPE.Add, true)) {
      return;
    }

    this.authService = authService;
    this.contactService = contactService;
    this.$state = $state;
    this.loadingService = loadingService;

    this.clearSearch();
  }

  (0, _createClass3.default)(ContactSearchController, [{
    key: 'searchContacts',
    value: function searchContacts() {
      var ctrl = this;

      if (!ctrl.searchTerm) {
        return;
      }

      ctrl.searched = true;

      ctrl.loadingService.showLoading('searchContact', 'Loading Contacts ...');

      ctrl.contactService.searchContacts(ctrl.authService.authData.currentLocation.key, ctrl.searchTerm).then(function (response) {
        ctrl.contacts = response.data.items;

        ctrl.contactNotFound = !(ctrl.contacts || ctrl.contacts.length);
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching contacts." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('searchContact');
      });
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent() {
      this.$state.go('contactList');
    }
  }, {
    key: 'createNewContact',
    value: function createNewContact() {
      var contact = {
        currentReg: this.regFilter,
        ownerName: this.authService.authData.firstName + ' ' + this.authService.authData.lastName,
        contactPerson: {
          firstName: this.firstNameFilter,
          lastName: this.lastNameFilter,
          title: 2
        }
      };

      this.$state.go('contactAdd', { contact: contact });
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.contacts = [];
      this.searchTerm = '';

      this.searched = false;
    }
  }]);
  return ContactSearchController;
}();

exports.default = ContactSearchController;


// WEBPACK FOOTER //
// ./client/app/components/contact/contactSearch/contactSearch.controller.js